import React, { useState, useEffect } from "react";
import {
  faCircleExclamation,
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import toast from "react-hot-toast";

export default function Title({ text }) {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  const [isMediumScreen, setIsMediumScreen] = useState(
    window.innerWidth > 768 && window.innerWidth <= 1024
  );
  const [isLargeScreen, setIsLargeScreen] = useState(
    window.innerWidth > 1200 && window.innerWidth <= 2000
  );
  const [is4kScreen, setIs4kScreen] = useState(window.innerWidth > 2000);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
      setIsMediumScreen(window.innerWidth > 768 && window.innerWidth <= 1024);
      setIsLargeScreen(window.innerWidth > 1200 && window.innerWidth <= 2000);
      setIs4kScreen(window.innerWidth > 2000);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="row row-bordered">
      <div className="col-xs-10">
        <h4>{text}</h4>
      </div>
    </div>
  );
}

export function SubTitle({ text }) {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 767);
  const [isMediumScreen, setIsMediumScreen] = useState(
    window.innerWidth >= 768 && window.innerWidth <= 1023
  );
  const [isLargeScreen, setIsLargeScreen] = useState(
    window.innerWidth >= 1024 && window.innerWidth <= 1200
  );
  const [isXlScreen, setIsXlScreen] = useState(
    window.innerWidth > 1200 && window.innerWidth <= 1400
  );
  const [isXxlScreen, setIsXxlScreen] = useState(
    window.innerWidth > 1400 && window.innerWidth <= 2000
  );
  const [is4kScreen, setIs4kScreen] = useState(window.innerWidth > 2000);

  const isIpadProPortrait = window.matchMedia(
    "(min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2)"
  ).matches;

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 767);
      setIsMediumScreen(window.innerWidth >= 768 && window.innerWidth <= 1023);
      setIsLargeScreen(window.innerWidth > 1024 && window.innerWidth <= 1200);
      setIsXlScreen(window.innerWidth > 1200 && window.innerWidth <= 1400);
      setIsXxlScreen(window.innerWidth > 1400 && window.innerWidth <= 2000);
      setIs4kScreen(window.innerWidth > 2000);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="row row-bordered">
      <div className="col-xs-10">
        <h4
          style={{
            fontSize: is4kScreen
              ? "2rem"
              : isXxlScreen
              ? "1.3rem"
              : isXlScreen
              ? "1.2rem"
              : isIpadProPortrait
              ? "1.9rem"
              : isLargeScreen
              ? "1.3rem"
              : isMediumScreen
              ? "1.4rem"
              : "1rem",
          }}
        >
          {text}
        </h4>
      </div>
    </div>
  );
}

export const useScreenSize = () => {
  // const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  // const [isMediumScreen, setIsMediumScreen] = useState(
  //   window.innerWidth > 768 && window.innerWidth <= 1023
  // );
  // const [isLargeScreen, setIsLargeScreen] = useState(
  //   window.innerWidth >= 1024 && window.innerWidth <= 1200
  // );
  // const [isXlScreen, setIsXlScreen] = useState(
  //   window.innerWidth > 1200 && window.innerWidth <= 1400
  // );
  // const [isXxlScreen, setIsXxlScreen] = useState(
  //   window.innerWidth > 1400 && window.innerWidth <= 2000
  // );
  // const [is4kScreen, setIs4kScreen] = useState(window.innerWidth > 2000);

  // useEffect(() => {
  //   const handleResize = () => {
  //     setIsSmallScreen(window.innerWidth <= 768);
  //     setIsMediumScreen(window.innerWidth > 768 && window.innerWidth <= 1024);
  //     setIsLargeScreen(window.innerWidth > 1024 && window.innerWidth <= 1200);
  //     setIsXlScreen(window.innerWidth > 1200 && window.innerWidth <= 1400);
  //     setIsXxlScreen(window.innerWidth > 1400 && window.innerWidth <= 2000);
  //     setIs4kScreen(window.innerWidth > 2000);
  //   };
  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  // return {
  //   isSmallScreen,
  //   isMediumScreen,
  //   isLargeScreen,
  //   isXlScreen,
  //   isXxlScreen,
  //   is4kScreen,
  // };

  const isPortrait = window.matchMedia("(orientation: portrait)").matches;
  const isLandscape = window.matchMedia("(orientation: landscape)").matches;

  const isIpadProPortrait = window.matchMedia(
    "(min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2)"
  ).matches;

  const isMediumIpadPortrait = window.matchMedia(
    "(min-device-width: 834px) and (max-device-width: 1112px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2)"
  ).matches;

  const getScreenSize = () => ({
    isExtraSmallScreen: window.innerWidth < 400,
    isSmallScreen: window.innerWidth < 767,
    isMediumScreen: window.innerWidth >= 768 && window.innerWidth <= 1023,
    isLargeScreen: window.innerWidth >= 1024 && window.innerWidth <= 1200,
    isXlScreen: window.innerWidth > 1200 && window.innerWidth <= 1400,
    isXxlScreen: window.innerWidth > 1400 && window.innerWidth <= 2000,
    is4kScreen: window.innerWidth > 2000,
    isIpadProPortrait,
    isMediumIpadPortrait,
    isPortrait,
    isLandscape,
  });

  const [screenSize, setScreenSize] = useState(getScreenSize);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(getScreenSize());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return screenSize;
};

export const useCustomScreen = () => {
  const [layout, setLayout] = useState({
    isLandscape1024: false,
    isPortrait1024: false,
    isIpadProPortrait: false,
    isMediumIpadPortrait: false,
  });

  useEffect(() => {
    const updateLayout = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const isLandscape = width > height;

      setLayout({
        isLandscape1024: width === 1024 && isLandscape,
        isPortrait1024: width === 1024 && !isLandscape,
        isIpadProPortrait: width === 1024 && height === 1366 && !isLandscape,
      });
    };

    updateLayout();
    window.addEventListener("resize", updateLayout);
    return () => window.removeEventListener("resize", updateLayout);
  }, []);

  return layout;
};

export const ShowToast = (message, success, error) => {
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();
  if (success) {
    return toast.success(message, {
      duration: 6000,
      icon: (
        <FontAwesomeIcon
          style={{
            fontSize: is4kScreen
              ? "1.9rem"
              : isXxlScreen
              ? "1.6rem"
              : isXlScreen
              ? "1.5rem"
              : isIpadProPortrait
              ? "1.8rem"
              : isLargeScreen
              ? "0.9rem"
              : isMediumScreen
              ? "1.4rem"
              : "1rem",
          }}
          icon={faCircleCheck}
        />
      ),
      style: {
        backgroundColor: "#FFC1B4",
        color: "red",
        fontSize: is4kScreen
          ? "1.9rem"
          : isXxlScreen
          ? "1.15rem"
          : isXlScreen
          ? "1rem"
          : isIpadProPortrait
          ? "1.8rem"
          : isLargeScreen
          ? "1rem"
          : isMediumScreen
          ? "1.1rem"
          : "1rem",
        marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
      },
    });
  } else if (error) {
    return toast.error(message, {
      duration: 6000,
      icon: (
        <FontAwesomeIcon
          style={{
            fontSize: is4kScreen
              ? "1.9rem"
              : isXxlScreen
              ? "1.6rem"
              : isXlScreen
              ? "1.5rem"
              : isIpadProPortrait
              ? "1.8rem"
              : isLargeScreen
              ? "0.9rem"
              : isMediumScreen
              ? "1.4rem"
              : "1rem",
          }}
          icon={faCircleExclamation}
        />
      ),
      style: {
        backgroundColor: "#FFC1B4",
        color: "red",
        fontSize: is4kScreen
          ? "1.9rem"
          : isXxlScreen
          ? "1.15rem"
          : isXlScreen
          ? "1rem"
          : isIpadProPortrait
          ? "1.8rem"
          : isLargeScreen
          ? "1rem"
          : isMediumScreen
          ? "1.1rem"
          : "1rem",
        marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
      },
    });
  }
};
